import { fromJS } from 'immutable';

import { ApiUrl2,UserToken } from '../../../helper/HelperAuth'
import { GetSenderAll } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (clientid, divisionid, type=null) => async (dispatch, getState) => {
    
    if(clientid == null || clientid === undefined || clientid === ""){
        dispatch({ type: GetSenderAll, data: fromJS({}) });
    }
    else{
        const Authorization = UserToken;

        const url = ApiUrl2 + 'config-sender-combo';


        var query = {
            "client-id": clientid,
            "division-id": divisionid
        };

        if (divisionid == "" || divisionid == null || divisionid == undefined) {
            query = {
                "client-id": clientid
            }
        }
        
        var paramBody = {
            "data": query
        };
    
        const argument = {  
            method: 'POST',
            headers : {
                'Content-Type':'application/json',
                'Authorization': Authorization,
                'template-type':type
            },
            body : JSON.stringify(paramBody)
        };  
    
        const response = await doFetch(url,argument);
        var data = fromJS({});
        var nData = fromJS({});
        if(response.ok){
            data = fromJS(await response.json());
            // data = data.get('Data');
            nData = data.get('Data').map((item) => {
                return item.set('sender-id-name', item.get('sender-name')+" - "+item.get('sender-id'))
            })
        }

        dispatch({ type: GetSenderAll, data: fromJS(nData) });
    }
};